// src/pages/BloodDonation.jsx
import Section from "../components/Section";

export default function BloodDonation() {
  return (
    <>
      <section className="bg-gradient-to-b from-red-50 to-white py-16">
        <Section eyebrow="Donate Blood" title="Your blood can keep someone with Thalassemia alive">
          <div className="grid md:grid-cols-2 gap-10 items-center">
            <div className="prose prose-slate max-w-none">
              <p className="text-lg text-slate-700">
                Children and adults with <b className="text-rose-600">Thalassemia Major</b> often need regular blood transfusions every 3–4 weeks.
                Safe, timely blood donation literally keeps them going.
              </p>
              <ul className="mt-4 list-disc pl-5 text-slate-700">
                <li>One donation can help multiple patients.</li>
                <li>Eligible donors can donate every 3 months (men) / 4 months (women).</li>
                <li>The process is safe, quick, and impactful.</li>
              </ul>
              <div className="mt-6 p-4 rounded-xl border-l-4 border-emerald-600 bg-emerald-50 text-slate-800">
                Not sure where to donate? Check your city’s blood banks or trusted NGOs. If you’re new, call ahead to confirm eligibility and timings.
              </div>

              <div className="mt-6 flex flex-wrap gap-3">
                <a href="/testing-locator" className="px-4 py-2 rounded bg-rose-600 text-white">Find Nearby Centers</a>
                <a href="/contact" className="px-4 py-2 rounded border border-slate-300 hover:border-rose-600">Partner with us</a>
              </div>
            </div>
            <img src="/donate-blood.jpg" alt="Donate blood" className="rounded-xl shadow-lg border" />
          </div>
        </Section>
      </section>

      <Section eyebrow="Eligibility" title="Who can donate? (general guidance)">
        <div className="grid md:grid-cols-3 gap-6">
          <Card title="Age & Weight">18–65 years, typically 45kg+ (check local rules).</Card>
          <Card title="Health">No fever, infections, or recent major illness.</Card>
          <Card title="Intervals">3–4 months gap between donations.</Card>
        </div>
        <p className="text-sm text-slate-600 mt-4">
          Always follow your local blood bank’s official guidelines. If on medication or recently ill, ask their medical officer first.
        </p>
      </Section>

      <Section eyebrow="Spread the word" title="Make a bigger impact">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <Action>Organise a campus or office donation drive.</Action>
          <Action>Bring a friend or family member to donate together.</Action>
          <Action>Share your donor story on social media to inspire others.</Action>
        </div>
      </Section>
    </>
  );
}

function Card({ title, children }) {
  return (
    <div className="rounded-xl border p-5 bg-white shadow-sm hover:shadow-md transition">
      <h3 className="font-semibold text-lg text-slate-900">{title}</h3>
      <p className="text-slate-600 mt-1">{children}</p>
    </div>
  );
}
function Action({ children }) {
  return (
    <div className="rounded-xl border p-5 bg-white shadow-sm">
      <p className="text-slate-800">{children}</p>
    </div>
  );
}
